import React from "react";

// components

import ProductsTable from "components/Cards/ProductsTable";

export default function Products() {
  return (
    <>
      <div className="flex flex-wrap">
        <ProductsTable />
      </div>
    </>
  );
}